export enum ExchangeRoute {
  HOME = '/',
  MAP = '/map',
  PORTFOLIO = '/portfolio',
  PORTFOLIO_ACCOUNT = '/portfolio/:account',
}
